import { memo } from "react";
import { GridActionsCellItem, type GridRowParams } from '@mui/x-data-grid-premium';
import Tooltip from '@mui/material/Tooltip';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { disableCta } from "features/onboarding/helpers";
import Icon from "ui/atoms/Icon";
import When from "ui/support/When";
import { Action, useApplicationTableResourceContext } from "../ApplicationTableResourceProvider";

const TableColumnActions = ({ row }: GridRowParams) => {
    const { onOpen } = useApplicationTableResourceContext();

    return (
        <When
            if={disableCta(row.status)}
        >
            <Tooltip
                arrow
                placement="left"
                title={(
                    <List
                        dense
                        disablePadding
                    >
                        <ListItem
                            disablePadding
                        >
                            <ListItemButton
                                onPointerDown={() => onOpen({
                                    action: Action.ApproveApplication,
                                    row
                                })}
                            >
                                <ListItemText
                                    primary='Approve Manually'
                                    sx={{
                                        color: 'success.main'
                                    }}
                                />
                            </ListItemButton>
                        </ListItem>
                        <ListItem
                            disablePadding
                        >
                            <ListItemButton
                                onPointerDown={() => onOpen({
                                    action: Action.RejectApplication,
                                    row
                                })}
                            >
                                <ListItemText
                                    primary='Reject Application'
                                    sx={{
                                        color: 'warning.main'
                                    }}
                                />
                            </ListItemButton>
                        </ListItem>
                        <ListItem
                            disablePadding
                        >
                            <ListItemButton
                                onPointerDown={() => onOpen({
                                    action: Action.IdleApplication,
                                    row
                                })}
                            >
                                <ListItemText
                                    primary='Mark as Idle'
                                    sx={{
                                        color: 'info.main'
                                    }}
                                />
                            </ListItemButton>
                        </ListItem>
                        <ListItem
                            disablePadding
                        >
                            <ListItemButton
                                onPointerDown={() => onOpen({
                                    action: Action.DeleteApplication,
                                    row
                                })}
                            >
                                <ListItemText
                                    primary='Delete'
                                    sx={{
                                        color: 'error.main'
                                    }}
                                />
                            </ListItemButton>
                        </ListItem>
                    </List>
                )}
            >
                <GridActionsCellItem
                    label="More"
                    icon={(
                        <Icon name="MoreVert" />
                    )}
                />
            </Tooltip>
        </When>
    );
};

export default memo(TableColumnActions);
